import React from 'react';
import { AttachmentButton } from '@common/components';
import { useNavigate } from '@common/hooks';
import { buildDialogUrl } from '@common/services';

export function ComplianceItemActionsUploadNew({
  complianceItemId,
}: {
  complianceItemId: string;
}) {
  const navigate = useNavigate();

  const openUpdateDrawer = () => {
    const updateDrawerUrl = buildDialogUrl(
      'compliance-item-add-attachment-drawer',
      {
        props: { complianceItemId },
      }
    );

    navigate(updateDrawerUrl);
  };

  return (
    <AttachmentButton onClick={openUpdateDrawer}>Add File</AttachmentButton>
  );
}
